// import { dashboards } from "./dashboards";
// import { BriefcaseIcon } from '@heroicons/react/24/outline'

import { forms } from "./forms";
import { leads } from "./leads";
// import { opportunities } from "./opportunities";
// import { calendar } from "./calendar";
// import { apps } from "./apps";
// import { marketing } from "./marketing";
// import { campaigns } from "./campaigns";
// import { query } from "./query";
// import { payments } from "./payments";
// import { reports } from "./reports";
// import { echo } from "./echo";
// import { automation } from "./automation";
import { settings } from "./settings";
// import { mioAI } from "./mio-ai"; 
// import { leadApplications } from "./leadApplications";
// import { verification } from "./verification";
// import { followups } from "./followups";
// import { projectManagement } from "./projectManagement";
import { jobs } from "./jobs";
import { reports } from "./reports";
import { whs } from "./whs";


export const navigation = [
  // Dashboard navigation
  leads,
  whs,
  jobs,
  // projectManagement,
  // followups,  // Follow-ups Calendar - after Lead Management
  // campaigns,  // Hidden - not implemented yet
  // application
  // verification,
  forms,
  // opportunities,
  // calendar,
  // marketing,
  // query,  // Uncommented to enable Query Manager
  // leadApplications,
  // reports,
  // payments,  // Hidden - not implemented yet
  // reports,  // Hidden - not implemented yet
  // echo,
  // automation,  // Hidden - not implemented yet
  reports,
  settings,
  // mioAI
];
